import { gql } from '@apollo/client';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
/**
 * @fragment SaleItemImageFragment
 * @since 1.0.0
 */
export const SaleItemImageFragment = gql `
  fragment SaleItemImageFragment on SaleItemImage {
    id
    createdAt
    updatedAt

    image {
      ...MediaFragment
    }
  }

  ${MediaFragment}
`;
